import { pipelineId, tagId } from '../fixture-ids';

// PIPELINE_TAG_ADDED_TO_PIPELINE is deliberately absent -- its legacy-shaped fixture lives in core
// (entries/pipeline-tag-entries.js, PIPELINE_TAG_ADDED_TO_PIPELINE_LEGACY_SHAPED), because it is the
// only fixture exercising the name-match downgrade and must survive deleting shape-map/legacy/.
// This file must not duplicate it.
export const pipelineTagLegacyAlternates = {};

export const pipelineTagLegacyFixtures = {
  PIPELINE_TAG_REMOVED_FROM_PIPELINE: {
    action: 'PIPELINE_TAG_REMOVED_FROM_PIPELINE',
    debugData: { pipelineId, tagId, tagLabel: 'production' },
  },
};
